module.exports = __webpack_public_path__ + "img/rolstavni.65ed6096.svg";